export const CloseSVG = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="close cancel x">
        <path
          id="shape"
          d="M12.0001 13.4143L17.5859 19.0001C17.9764 19.3906 18.6096 19.3906 19.0001 19.0001C19.3906 18.6096 19.3906 17.9764 19.0001 17.5859L13.4143 12.0001L19.0001 6.41438C19.3906 6.02386 19.3906 5.39069 19.0001 5.00017C18.6096 4.60964 17.9764 4.60964 17.5859 5.00017L12.0001 10.5859L6.41429 5.00008C6.02376 4.60955 5.3906 4.60955 5.00008 5.00008C4.60955 5.3906 4.60955 6.02376 5.00008 6.41429L10.5859 12.0001L5.00008 17.586C4.60955 17.9765 4.60955 18.6096 5.00008 19.0002C5.3906 19.3907 6.02376 19.3907 6.41429 19.0002L12.0001 13.4143Z"
          fill="#2B2D33"
        />
      </g>
    </svg>
  );
};
